// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as FilterAllocationTableTab from "../../view/components/allocation-dashboard-home/table-component/FilterAllocationTableTab.bs.js";
import * as AllocationCampaignApiModel from "../api-model/AllocationCampaignApiModel.bs.js";

function convertMetersToKms(distance_in_meters) {
  return distance_in_meters / 1000.0;
}

function apiModelToState(res) {
  return {
          campaigns: List.map((function (campaign) {
                  var value = campaign.effective_till;
                  var zones = campaign.zones;
                  var clusters = campaign.clusters;
                  var data = campaign.creator_info;
                  var approver = campaign.approver_info;
                  return {
                          geo_region_id: campaign.geo_region_id,
                          vehicle_id: campaign.vehicle_id,
                          name: campaign.name,
                          id: campaign.id,
                          campaign_status: FilterAllocationTableTab.fromString(campaign.campaign_status.toLocaleLowerCase()),
                          effective_from: Timestamp$Catalyst.make(campaign.effective_from),
                          effective_till: value !== undefined ? Caml_option.some(Timestamp$Catalyst.make(value)) : undefined,
                          filters: {
                            allocation_radius: {
                              auto: campaign.filters.allocation_radius.auto / 1000.0,
                              manual: campaign.filters.allocation_radius.manual / 1000.0,
                              radius_delta: Belt_Option.map(campaign.filters.allocation_radius.radius_delta, convertMetersToKms)
                            },
                            dry_run: {
                              threshold: campaign.filters.dry_run.threshold / 1000.0,
                              ratio: campaign.filters.dry_run.ratio,
                              radius_delta: Belt_Option.map(campaign.filters.dry_run.radius_delta, convertMetersToKms)
                            },
                            maps_distance: {
                              manual: campaign.filters.maps_distance.manual / 1000.0,
                              auto: campaign.filters.maps_distance.auto / 1000.0,
                              radius_delta: Belt_Option.map(campaign.filters.maps_distance.radius_delta, convertMetersToKms)
                            }
                          },
                          zones: zones !== undefined ? List.map((function (zone) {
                                    return {
                                            name: zone.name,
                                            id: zone.id
                                          };
                                  }), zones) : /* [] */0,
                          clusters: clusters !== undefined ? List.map((function (cluster) {
                                    return {
                                            name: cluster.name,
                                            id: cluster.id
                                          };
                                  }), clusters) : /* [] */0,
                          creator_info: data !== undefined ? ({
                                created_by: {
                                  name: data.created_by.name,
                                  email_id: data.created_by.email_id
                                },
                                created_on: Timestamp$Catalyst.make(data.created_on)
                              }) : undefined,
                          approver_info: approver !== undefined ? ({
                                approved_by: {
                                  name: approver.approved_by.name,
                                  email_id: approver.approved_by.email_id
                                },
                                approved_on: Timestamp$Catalyst.make(approver.approved_on)
                              }) : undefined
                        };
                }), res.campaigns)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(AllocationCampaignApiModel.t_decode(json), "FilterAllocationCampaignEntityMapper.res"));
}

export {
  convertMetersToKms ,
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
